import { Navigate, Route, Routes } from 'react-router';
import { ROUTE } from '../../features/navigation/index.js';
import {
  AttentionPage,
  CalendarPage,
  OccurrencePayPage,
  OperationDetailPage,
  PaymentCreatePage,
  PaymentDetailPage,
  PaymentEditPage,
  PaymentsPage,
  ReferencesPage,
  SummaryCategoryPage,
  SummaryMerchantPage,
  SummaryPage,
} from '../../pages/index.js';
import { TabLayout } from '../tab-layout/tab-layout.js';

export const AppRouter = () => (
  <Routes>
    <Route element={<TabLayout />}>
      <Route path={ROUTE.attention} element={<AttentionPage />} />
      <Route path={ROUTE.summary} element={<SummaryPage />} />
      <Route path={ROUTE.payments} element={<PaymentsPage />} />
      <Route path={ROUTE.calendar} element={<CalendarPage />} />
      <Route path={ROUTE.references} element={<ReferencesPage />} />
    </Route>
    <Route path={ROUTE.paymentCreate} element={<PaymentCreatePage />} />
    <Route path={ROUTE.paymentDetail} element={<PaymentDetailPage />} />
    <Route path={ROUTE.paymentEdit} element={<PaymentEditPage />} />
    <Route path={ROUTE.occurrencePay} element={<OccurrencePayPage />} />
    <Route path={ROUTE.summaryCategory} element={<SummaryCategoryPage />} />
    <Route path={ROUTE.summaryMerchant} element={<SummaryMerchantPage />} />
    <Route path={ROUTE.operationDetail} element={<OperationDetailPage />} />
    <Route path="*" element={<Navigate to={ROUTE.attention} replace />} />
  </Routes>
);
